import { render, staticRenderFns } from "./RelatorioVendasAssinatura.vue?vue&type=template&id=cb7d5b48&"
import script from "./RelatorioVendasAssinatura.vue?vue&type=script&lang=js&"
export * from "./RelatorioVendasAssinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports